// extracted by mini-css-extract-plugin
export default {"collapseContainer":"Collapse_collapseContainer__Cj4SS"};